import { render, staticRenderFns } from "./appQian.vue?vue&type=template&id=a60295dc&scoped=true&"
import script from "./appQian.vue?vue&type=script&lang=js&"
export * from "./appQian.vue?vue&type=script&lang=js&"
import style0 from "./appQian.vue?vue&type=style&index=0&id=a60295dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60295dc",
  null
  
)

export default component.exports